import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row d-flex align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
  /*#__PURE__*/_createElementVNode("h2", null, " Annuity and My Salary Deferral Summary ")
], -1)
const _hoisted_4 = { class: "col-md-2 text-center" }
const _hoisted_5 = { class: "col-md-2 text-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccountSummary = _resolveComponent("AccountSummary")!
  const _component_ContributionChart = _resolveComponent("ContributionChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: { name: 'annuity-summary', params: { year: $setup.year - 1 } },
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Previous Year ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'annuity-summary', params: { year: $setup.year + 1 } },
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Next Year ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Loading... "))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_AccountSummary, { summary: $setup.summary }, null, 8, ["summary"]),
          _createVNode(_component_ContributionChart, {
            graphData: $setup.graphData,
            title: "Employer and My Contributions - Month-by-Month"
          }, null, 8, ["graphData"])
        ]))
  ]))
}